<app-common-grid [GridColumns]="gridColumns" [pageName]="'Market Abuse'" [exceptionCode]="'0004'"></app-common-grid>